import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wage-payroll-grid wage-payroll-grid--director-allowances wage-payroll-grid--director-premium-pay"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["disabled", "onClick"]
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = { class: "wage-payroll-premium__amount wage-payroll-grid__input wage-payroll-grid__input--readonly" }

export type HomeWageDirectorPremiumPaySwitchType = 'overtime' | 'night' | 'holiday';

export interface HomeWageDirectorPremiumPaySwitchItem {
  type: HomeWageDirectorPremiumPaySwitchType;
  label: string;
  enabled: boolean;
  hours: number;
  amount: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageDirectorPremiumPaySwitches',
  props: {
    items: {},
    disabled: { type: Boolean },
    formatAmount: { type: Function }
  },
  emits: ["update:enabled"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (__props.items.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.type
          }, [
            _createElementVNode("label", {
              class: "wage-payroll-grid__label",
              for: `director-premium-pay-${item.type}`
            }, _toDisplayString(item.label), 9, _hoisted_2),
            _createElementVNode("div", {
              id: `director-premium-pay-${item.type}`,
              class: _normalizeClass(["wage-payroll-premium wage-director-premium-pay__row", { 'wage-director-premium-pay__row--off': !item.enabled }])
            }, [
              _createElementVNode("div", {
                class: "wage-director-premium-pay__choice",
                role: "group",
                "aria-label": `${item.label} 지급 여부`
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["wage-director-premium-pay__choice-btn", { 'wage-director-premium-pay__choice-btn--active': item.enabled }]),
                  disabled: __props.disabled,
                  onClick: ($event: any) => (emit('update:enabled', item.type, true))
                }, " 지급 ", 10, _hoisted_5),
                _cache[0] || (_cache[0] = _createElementVNode("span", {
                  class: "wage-director-premium-pay__choice-sep",
                  "aria-hidden": "true"
                }, "|", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["wage-director-premium-pay__choice-btn", { 'wage-director-premium-pay__choice-btn--active': !item.enabled }]),
                  disabled: __props.disabled,
                  onClick: ($event: any) => (emit('update:enabled', item.type, false))
                }, " 미지급 ", 10, _hoisted_6)
              ], 8, _hoisted_4),
              _createElementVNode("span", _hoisted_7, _toDisplayString(__props.formatAmount(item.amount)), 1)
            ], 10, _hoisted_3)
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})